import React from "react";
import RiskDetailsView from "./components/risks/RiskDetailsView";

export default function RiskDetailTabs({ riskId, onRiskUpdated, onOpenInPanel, mode = "drawer" }) {
  return (
    <RiskDetailsView
      riskId={riskId}
      // Bubble successful saves to parent containers so they can refresh list/heatmap state.
      onRiskUpdated={onRiskUpdated}
      onOpenInPanel={onOpenInPanel}
      mode={mode}
    />
  );
}
